import { useLocation } from 'react-router-dom';
import { PageOutlet } from '@oysterjs/ui/navigation';
import { PageTitle } from '@oysterjs/ui/page';

import { triggersPage, usePageHeading } from '~/components/navigation';
import { CreateWorkflowDefinitionButton } from './create-workflow-button';

export { WorkflowsDebugPage } from './debug';

export const WorkflowsPage = () => {
  const location = useLocation();
  const { title, description } = usePageHeading(triggersPage);
  const showCreateButton = /\/workflows\/(gallery|executions)/.test(location.pathname);

  // No eyebrow: the section and its first tab share a name, so it would only
  // repeat the title.
  return (
    <PageTitle
      title={title}
      description={description}
      menu={showCreateButton ? <CreateWorkflowDefinitionButton /> : undefined}
    >
      <PageOutlet />
    </PageTitle>
  );
};
